<template>
    <div id="lotNames" v-if="identityCards && identityCards.length > 0" :aria-hidden="alertVisible">
        <div class="title">
            <div class="bar">请确认您的实名信息</div>
            <div class="cont" v-if="identityCards.length ===1">您的账号包含以下实名信息，请确认</div>
            <div class="cont" v-if="identityCards.length >1">请选择本人身份证，确认后滴滴将仅保留您选中身份证下的订单、余额等信息</div>
        </div>
        <div class="item-group">
            <div v-for="item in identityCards" :key="item.id_no">
                <div class="item" :class="[((item.current && !handClicked) || (item.id_no == selectItem.id_no && item.name == selectItem.name && handClicked)) ? 'selected' : '']" @click="select(item,$event)">
                    <div class="icon"></div>
                    <div class="info">
                        <div class="name">
                            <span>{{item.name}}</span>
                            <span class="tag" v-for="(_item, index) of item.tag || []" :key="'idn' + index">{{_item}}</span>
                        </div>
                        <div class="id">{{item.id_no}}</div>
                    </div>
                    <div class="sel"></div>
                </div>
            </div>
        </div>
        <div class="btn1" :class="[isBtnAble?'light':'gray']" @click="bind">去认证</div>
        <div v-if="isReameShow" class="btn2" @click="goClearName">以上实名都不是我的</div>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import { mapGetters } from 'vuex'
import { setPageTitle, query } from '@didi/public-sdk'
import { goClearNamePage, sendOmega } from '../config/state'
import { reanmeApolloInfo, initUnVerifiedRouter, showAlert, showConfirm } from '../api'
import { name_auth_omega_summary } from 'common-js/omega'

export default {

  data () {
    let rquery = query.resolveQuery(location.href)

    return {
      selectItem: {},
      unselectedItem: {},
      handClicked: false,
      query: rquery,
      isBtnAble: false,
      isReameShow: false,
      alertVisible: false,
    }
  },
  computed: {
    ...mapGetters(['identityCards', 'cell', 'env', 'unVerified']),
    currentItem () {
      if (this.identityCards) {
        var data = this.identityCards.filter(function (item) {
          return item.current && item.current === true
        })
        return data[0] || null
      }
      return null
    },
    isDiffernt () {
      if (this.identityCards) {
        let tmp = this.identityCards
        return (tmp.length === 2) && (tmp[0].id_no !== tmp[1].id_no || tmp[0].name !== tmp[1].name)
      }
      return false
    },
  },
  methods: {
    select (_item) {
      this.selectItem = _item
      this.selectItem.phone = this.cell
      this.handClicked = true
      this.isBtnAble = true
    },
    bind () {
      sendOmega(name_auth_omega_summary['trinity_idshow_ident_ck'])
      if (!this.currentItem && !this.selectItem.id_no) {
        return
      }
      let _this = this
      let c_desc = ''
      let title = ''
      let confirmText = '去完善'
      // 假如没有select,默认为一开始的currentItem
      if (!_this.selectItem.id_no && _this.currentItem) {
        _this.selectItem = _this.currentItem
        _this.selectItem.phone = _this.cell
      }
      if (_this.isDiffernt) {
        _this.unselectedItem = _this.identityCards.filter(item => {
          return item.id_no !== _this.selectItem.id_no || item.name !== _this.selectItem.name
        })[0]
        // 司机：2； 乘客：1
        let role = _this.unselectedItem.role === 1 ? '乘客' : '司机'
        title = '风险提醒'
        confirmText = '确定'
        c_desc = `<div class="c-ul"><div class="c-li">绑定后，${_this.unselectedItem.id_no}的<span class="didiOrange">${role}</span>身份信息如订单、余额等将不在您的账户中显示，您可以通过绑定新的手机号找回以上信息</div></div>`
      } else {
        c_desc = `<div class="c-ul"><div class="c-li">您的手机号“${_this.selectItem.phone}”与身份证“${this.selectItem.id_no}”的认证关系安全系数较低，请完善实名认证</div></div>`
      }
      this.$store.commit('ROLEID', _this.selectItem.role)
      if ((_this.currentItem && _this.currentItem.id_no === _this.selectItem.id_no && _this.currentItem.name === _this.selectItem.name) || !_this.currentItem) {
        let omegaEvent = _this.isDiffernt
          ? name_auth_omega_summary['trinity_idshow_toastaway_sw']
          : name_auth_omega_summary['trinity_idshow_toastident_sw']
        sendOmega(omegaEvent)
        _this.alertVisible = true
        showConfirm(_this, {
          title: title,
          content: c_desc,
          confirmText: confirmText,
          cancelText: '取消',
          onConfirm: () => {
            _this.alertVisible = false
            let omegaConfirmEvent = _this.isDiffernt
              ? name_auth_omega_summary['trinity_idshow_toastaway_ok_ck']
              : name_auth_omega_summary['trinity_idshow_toastident_go_ck']
            sendOmega(omegaConfirmEvent)
            // _this.$router.replace({name: 'nameID'})
            initUnVerifiedRouter(_this)
          },
          onCancel: () => {
            _this.alertVisible = false
            let omegaCancelEvent = _this.isDiffernt
              ? name_auth_omega_summary['trinity_idshow_toastaway_cancel_ck']
              : name_auth_omega_summary['trinity_idshow_toastident_cancel_ck']
            sendOmega(omegaCancelEvent)
          }
        })
      } else {
        sendOmega(name_auth_omega_summary['trinity_idshow_toastwrong_sw'])
        c_desc = `该实名信息与您当前账号所绑定的实名不一致，请登录该实名对应的账号进行绑定。`
        this.alertVisible = true
        showAlert(this, {
          content: c_desc,
          onConfirm: () => {
            sendOmega(name_auth_omega_summary['trinity_idshow_toastwrong_ck'])
            this.alertVisible = false
          }
        })
      }
    },
    goClearName () {
      sendOmega(name_auth_omega_summary['pub_trinity_idshow_appeal_ck'])
      goClearNamePage()
    }
  },
  components: {
  },
  mounted () {
    sendOmega(name_auth_omega_summary['trinity_idshow_sw'])
    if (this.currentItem) {
      this.isBtnAble = true
    }
    setPageTitle({
      title: '统一实名认证'
    })
    // reanmeApolloInfo(this)
    this.isReameShow = false
  }
}
</script>
<style lang="scss">
@import '~common-css/mixins.scss';
.didiOrange{
  color: #FC9153;
}
input::-webkit-input-placeholder {
  color: #ccc;
}
.cube-dialog-confirm .c-ul{
  text-align:left;
}
.cube-dialog-confirm .c-li::before{
  content:'';
  position:absolute;
  width: 0px;
  height: 0px !important;
  border-radius: 50%;
  margin-top: px2rem(12);
  margin-left: px2rem(-24);
  background: #4A4C5B;
}
.cube-dialog-confirm .c-li{
  margin-bottom:px2rem(24);
  padding-left:px2rem(24);
}
#lotNames{
  position: absolute;
  height: 100%;
  width: 100%;
  background: #fff;
  .title{
    padding:px2rem(40) px2rem(96);
    .bar{
      font-size:px2rem(48);
    }
    .cont {
      margin-top: px2rem(15);
      line-height: 1.2;
      color:#333;
      font-size:px2rem(28);
    }
  }
  .item-group{
    width:px2rem(600);
    border: 1px solid #EBEBEB;
    margin:0 auto;
    border-radius: 2px;
    .icon{
      background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAABO5JREFUaAXdmj2M3EQUx+093+m+9r635iiiK6AESpSkQEpBFwEVLUgBhSpdKrp0CEUibSpAdClOShGOlCQlKaIUkHpv705Z3efeB//fymN5d2e8ttf7OZJ3x29m3vv/5828sWfsewWmq6srf39//8PLy8vrvu9/oPstXe8pvyQz5dBUXbJ3kr3V9Vr5V6VSaWd1dfUf3V8VBcfvVZGA+QcHB59eXFx8rfzn0lfJqbMqYk+mpqYer6ysPO+VZG5iENrb2/tC3vlRRK7lJONq9kZevL+2tvZ7XoK5iFWr1Rsy+EDkPnIhK0IuGy9l416lUvkzq75MxDTk3m80Gg9l5FZWQz3W356enr6jIfpvWj2piclLBIQ/1IPraZUXWU+2a7J9W97bSaO3lKaSSH0jxU+HRQqM2AYDWNJgTvSYlE3VarWf9H8njbJB1RHBh+vr63f1f+GyGbgKkI8iKXDR0cJG9jt+bMnpsdDlv9gajZDsW825RzY8VmJhoGBOTdsajYpMQ7EhjJ/ZAkoHMUL6+fn5CzUYSvTL2mkiVwuC4OP2paAjKrJOjQspOgGs4dra0ictHtMQvKHSZy01xufmZvwJJfKYmMur/oPx4dGKFOxwMNIoo/D5pR5ofzUFtv+ZmRmvXC57UmIr7ptMgL16ve6dnZ0l2tCD81da336jUtNjMA2f0hMbDoMUgOhIbHdLcDBeay7QvE+pUddXD+Op3d3dbjYKLd/Y2Eg7Sq6FXP5qeoyXxEKRDFGZ4VLCdbp4852IBBc4BexRiFHe1/mOziDA6PXeU891newMsaSUc8hX4BRowl1PUp6lbHFx0ZudnY2aEMWIZurBSDaIDJwCBQR2k3q2h6fipFCIjOv09NSqP6dHrLriQjgxx7biwrx5rSHWpiaSWgv7JIQTaDaL0O8i4CJchM0EHZsQ677yJWgwRS5ipnzA/2UW6EKIHR8fN+eTXiEiDkRG5K7Up6iIubJ9YriQJMgJQIeHh1EEbL9PaNqXIrq3rquQl0o8FE/t9/Ey8v2KilJdx2MQ6ykRIObn573l5eXomY45t7S01JSzYA8yabS8w2P/6drUlSvNzc15XLboByEIs76dnJx4R0dHuWxkbaROfVvSz+usDU19gC8sLFhJmTr8G4/GA0u8vOg8nAK57VVexdpPz9SU+tooitq4omKvcw9O6szSTmQpY4bIlyUx7waR4BRwkqgeqspg5id8ngFdz4FpCPTqGYeNKpyYY+ziPHFUGjsxXODUXKAVBB6PHQMHYMOlOeg1V3wNC6Jj4r6HdoCidcqht29i5nN4EJFk440C0lbksWZGZ75JLSgbxksjdiGF7W5JQeM+XKgXhSm8ph75W/99PVfuBi5vuQi91Ij6xBCLHoIRKN3Lq3jY7cBuSIElIsZNuPe9TX7M0nZ83x7sLcQQcDov5jXy45DACuZ2rB3EOGeSW2+rQaO98qjdgxGs7Wdj4OwghpATQjX4nvwoJzCC1YbRSoyKavBIPcLHKiOZwAZGFzgnMRoofP4wiuTAJGx3XaSQR+tYUiW+IJCyn+X6bO8pSUpzlAkDc4rh5/SUUZuKGJXDLwkm65MjiKmXdjidV3YY69w2tsEAljQptcfiyjiE17CYnM/64uQ01ifvQ8x2ghyPag9xMj6djZMzebzY/rGzyjZ1sY1uttIH8rHz/8HaNJuMZNtGAAAAAElFTkSuQmCC');
      width:px2rem(54);
      height:px2rem(54);
      background-size:contain;
      display:inline-block;
      margin: px2rem(55) px2rem(28);
    }
    .info{
      display:inline-block;
      font-size:px2rem(28);
      vertical-align: top;
      height:100%;
      .name{
        display:inline-block;
        margin-top:px2rem(32);
        vertical-align: middle;
        &>span{
          display: inline-block;
          vertical-align: middle;
        }
        &>.tag{
          margin-left: px2rem(16);
          padding: 1px 2px;
          font-family: PingFangSC-Regular;
          font-size: px2rem(20);
          color: #4A4C5B;
          box-sizing: border-box;
          @include border-1px(#4A4C5B, 2px, solid)
        }
      }
      .status{
        display:inline-block;
        margin-top:px2rem(32);
        margin-left:px2rem(40);
        border:1px solid #ccc;
        color:#ccc;
        border-radius:2px;
        font-size:px2rem(24);
        padding:0 px2rem(10);
      }
      .id{
        font-size:px2rem(32);
        padding-top:px2rem(16);
      }
    }
    .sel{
      background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAupJREFUWAnNl7+LE1EQx283P64Q7MwvrtTCFHYHV0msFIWTq6+4Qk6wPRu5AwvBs7r8B3amFgRBsNBGCFyncJWgRdiY2B2I3iVk/XyXfUsuebtJNgm6EGZ2Zt58v2/m7ct7zsqUj+/7+Xa7fQu56ThOFVlBlhnuoHvoHvIE+aZcLn9Ank+T2pkU1O12S/1+/ylx2wBcnhQvP+CniEY2m31WKBR+JI2JJQDYKjM+YPAe+qWkJHE+iPzCV6ciz9HPbHFWApp1r9d7zYAN26AUtmYul9uyVWOMQKfTuUHJ3wKylgIoaUiLltwrFoufh4MuEAhnfrwEcIPZohLrw5VwjUc9D8u+6JkbCMk1YQjLGCMC4YJbVM9NfpvcCLECX9CC8FP7mna121CSbPo6WA9X1YqgAvrOlwT+20ZEWOHesuLykido2xY4j41ZvnRdt4r8FpNHG1vepR/aXqfa4WISjZkFzuazy+87zvdjARiEKWxVYNMWkNZmwJG+53lH5H8Yl0vYLoHVuIBZ7RbwvaQcwlYFKklB0/pmBVdeYasCsQTwDfh9mkQiDbhyCjvaiGwgBDxgId1EvrL5wyTBgiPG9Dyx7CN5fLXAGzFGr/iukXgAiR0bCWzzgKsFbbUgicA+K1n/5WMk5gUPq+dlYXHCSy2a9oiCXyTUrwP0Hb5dRZxRlV1sacoeIQjbIfltlHeRNUYB7LBSqYiE1o0/L7hgyHFHB0odNn8iJ+6GhoQGQ/wFY55IT/OQ65QqXsminJOsQZJHkxIBaNrxZzAYpAYPcRrC/j/+jsMjUn1SBRbor5tjWXQmpLyrtOIjIMs+FTVZzDXKHxzTo51QBh2dIdDit6xHh9ItAy6QiIBeVJZMJnMXdRkkWsptSi88PRcIyFAqlb7o6Iza1PuCHl1M1pV7NF+0BkYd4ZrYp1yP0VNfzRh7RM8Ph8s+jBVLwAT9s8upIWAkM9GOWUPeZzbXkbqeB2cJdF3P28iZr+d/ATBrrMZTVoCLAAAAAElFTkSuQmCC');
      width:px2rem(32);
      height:px2rem(32);
      background-size:contain;
      // margin-top:px2rem(67);
      // display: inline-block;
      // position: absolute;
      // margin-left:px2rem(86);
      float: right;
      margin-top: px2rem(67);
      margin-right: 0.4rem;
    }
    .item{
      // height:px2rem(165);
      color:#999;
      &::after{
        content:'';
        border-bottom:1px solid #F5F5F5;
        display: block;
        // margin-top: -0.4rem;
      }
    }
    .selected{
      color:#666;
      .icon{
        background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAABXtJREFUaAXdWk2IHEUUfq+mx02iiYYluB6Mu4S4wsYIujGgIjFKwEOih50xIHhdYXeSnHIQPHkTL8lkwVxFIc4uelhFCBJjIB6SgCKusOzBBEEWlqAmIsRs1/O9mulmtru6p7un528Ldqf6VdV77+vqevXqvULIsRARwrnyPq3pECBMEMA4AjwBQDuAcLsRhXQXAO9w2y1uWwaCJaXwMszWfkFEJudTmHd7xYCpll/WQO8wp6P8vCsLRwa1xuMWFeAnUKldaRdkZmACyD1XLqPWH/Br3psFTNQYVmqFlHq/MFurZQWYCRidKb/iov4QiCajlMuFjnijQOo0nqx9l5ZfKmBULY25RHMM6PW0gtrqj/hNAXEGK/O/JeWTGBhVpw5pogUiGE7KPM9+iHBbIU5hZeFyEr4qSSf37NS0JrjYK1Cio8gWHUSXJDrHzhjVSgW9SmfYUMwkYdatPmxQ5tQInsTyvBsl04lqEHo/ghK95EXrVanBrPlv+Rc5YzLlzOBjy5i+IfHMvVs4sXDeppAVWN1QyJqiom1Qv9AY2H2FcMRmUELAxKRr0td7aSjSvLi6tVQHgltByCrKPjUooOQFiK5mbw28jQ0zZjwKcC8F+gzEYwEKh5s9FH/GeD2hcZMGAkZYSdFdMHgtfmW9WnoLtL7gNVh/974I6kgFsBC7S1iHtkMkdx30xSq7xlfj2Sh13KnMfy6dzIwJUvHS40dx5x6AEp3kRYrsVsWcNBqzVn/1fJ5KcvTwZor3uFYycm3nvSrRV2IwMBYW/r2ZscYhMVdlesXMw6IaC+5orxTpgFw5xaMjMQquZDrOW5XacxDwkceA/mZn7uaPAOv3rN2EKJ9YXMnyyRssjMkxgZc47knbnCHAw9OgnpJPvF7o959Bf/0RwH//eqSu/AomR6JJHClqv+x+ZgMoYYiP7wccmwRavmLln2VGrIyCRMakGNN4kJ7lGbftsA8rDtnpHaQKJoVEo7nI2BoB7MGdubBPw0QwcRgP6oHMNCNtfYtbbVSA4hY7vZNUxuTUI7TtLzK68SXQ2HOAw7t9lemvVaDrX/jPwUonrKKRwVFn3wkOCk39zJZPX/0UxK+TQtoF+uEzgHv/pGaVxwC2ihxLzyuk9ucfAO593qDYU9PsA8hzTOmcVaS7/CkCJwnajBU+PAI48Srgky8BPlBfa+gUQR17D4g9clr6FqAFyBj8GZrwjsN+/U0+ho5mGM1DEHDyTcBn3wDc8lCIBW4f5rZjQBOvAf30FdA19jRIh/rlTWCLcYtjIZzKyVp2jYJ64W0rqGaWOLQN1MEywKN7mskdqwsm+RSXskrAkXRJFmTvhFZXfHFRVrHttWdybpJ0y1oaFjDxcPYnu1EkkeiYTGK1tJbFw6dfL4HLf1lL2zNjEcyxxjXBxAkMkx5dtPQZVNKiYDIbtEmPDiqMgN4eFhOlkhOnPju1zGYy1hqomQuJYg8BWbk8mkjV3PFYXgxmRZ1YGPdnTCqS840dxY0SAvNcplZ982z3w28tmAqGxtLiHbZRZNbcaukab9adzSt7AvP+lXx1Zf55D5jvBAtBEtl5y+sWP5OErxtCI9IHJk8m9s2J7G4pk5sc1rk5bi98NwATgsnOcyJb6oNQJI0kOgd1DQGTPJPJznNSLdi53555+XDiT24ShK9JhICJ8o0MYetgee+RVmzZTFHLCkwa2EE9z29kTur9WEQ30TFKt0hgMkA9ve9UP4ITneQ6RBQoofv7WFwndlanub3Ke10xrl+n2xiQrPtK3Ex5OiQCJp035ZUjASaLVKE6AL3Y51imyI4yFKJfsCSeseaBm+5a3wZw4ltutouYQYCwma7ONoPz6nJCCF12ltCe5Ae6fNn5f17iJsZZ2BSuAAAAAElFTkSuQmCC');
        width:px2rem(54);
        height:px2rem(54);
        background-size:contain;
        display:inline-block;
        margin: px2rem(55) px2rem(28);
      }
      .sel{
        background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAxhJREFUWAnFVz1oVEEQnpl3xkKwE5NgI2ihqF3ASmKlKChyJo2ghSgkclekEgMaDqOVB14wVnYK4iUIgiAIWgkBOwUrCwu5nNgJwb97O87s3YbLZd96792dbrN3OzPf973Z2X3zELoc/GRiCL7gUWPMKUbYj8CjwDACiAjANQasIcMHInoGO/k1TlZ/dQMtweHB9yaGTWyuA+A5Zt4e9m5aRdM3EfWIIirhlWo9FJMogCuFrYZXZyV4hoG3hUCSbAi4JrYy4cg8Fhd++vy8AvSp49g8lRQf9gWlXkNYiSI648vGJgG8mD9kGvCcGXalJgoESKV8phycxOnld+1uGwS09vttv8kdoRUR0Vh7JsgZdc817YMiVx7FthzC5XjXBdiC69eeO3TfLByt4rZWuwU29Q3+mLXafTyhNT0dlMM9uhU2A3rOB0EuRN99QpSrebfI7aI3nKnz124vGR+gb01S+4CGttw0vxuvBHt3p49eVjSMO0iv14GQF5cu4dTjT1J5LzvJ9b/lFG7Su93nkHXNPrmSI3Jcyd9hgMtJWMpN+mJJcki7vomcYSaEodxk32ohry5tackVVrnlFOBoEodUsRGvN0l2t56FvBmLKiB5MOLFqHDwiAh5mOSVnVwQpRJFANeSwXkv4pyh4oELPhE9kSspwippJ5MkQAReiytn530ieiYXUuUmbaOSBOi6T0Q/yBVbuZEXJo/FJn6hC6Eh5/pWVFyaZZ6Tbbsh5dE65385aiHMiKLjqa5iJ0JB47v523LJXA0RhGyCZa9iyaaAVfKL8q6eCgU4m4qQ4vnBhktuLcsszcn9qLg8ndNg7V5Ng89380bUmpDq6WnIiVqjCO0DyH5KMTRb53JPqOmCy64tswI0VltnSe1KOpwM3sJhuVqhtgYczH9tSlWEbZGQTmj36kT1a7YdsWJ3fCmtb4EjwkL1vRTlWF+3Q9Ou7bhgOx43bxKgBlUZwei4qC5pxTrntLPGKobF6nhyh7WhBtxi+9yqi3//cdouQn/bz/M6jxuG04y8D1n7CPlEtwNr0t2sZvk8/wMp/pOcY7oFMwAAAABJRU5ErkJggg==');
        width:px2rem(32);
        height:px2rem(32);
        background-size:contain;
        float: right;
        margin-top: px2rem(67);
        margin-right: 0.4rem;
      }
    }
  }
  .light{
    background: #4A4C5B !important;
  }
  .btn1{
    position: absolute;
    left:50%;
    transform:translateX(-50%);
    bottom: px2rem(248);
    width: px2rem(600);
    height: px2rem(100);
    text-align: center;
    line-height: px2rem(100);
    background: #CCC;
    border-radius: 4px;
    font-size:px2rem(32);
    color:#fff;
  }
  .btn2{
    position: absolute;
    left:50%;
    transform:translateX(-50%);
    bottom: px2rem(128);
    width: px2rem(600);
    height: px2rem(100);
    text-align: center;
    line-height: px2rem(100);
    background: #fff;
    border-radius: 4px;
    font-size:px2rem(32);
    color:#fff;
    border:1px solid #ccc;
    color:#ccc;
    box-sizing:border-box;
  }
}

</style>
